import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive } from "vue";
import moment from "moment";
import { invoiceSuccessList } from "@/util/type";
export default {
  name: "OpenInvoiceDetail",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      bankNo: "",
      driverIdentityNumber: "",
      failReason: "",
      invoiceAmount: 0,
      invoiceCode: "",
      invoiceId: 0,
      invoiceItems: "",
      invoiceMaker: "",
      invoiceNo: "",
      invoicePdfUrl: "",
      invoiceReceiver: "",
      invoiceRequestStatus: 0,
      invoiceStatus: 0,
      number: 0,
      openBank: "",
      taxNo: "",
      taxableAddress: "",
      unit: "",
      workAddress: "",
      orderList: []
    });
    onMounted(() => {
      invoiceDetail();
    });
    const invoiceDetail = async () => {
      const {
        bankNo,
        driverIdentityNumber,
        failReason,
        invoiceAmount,
        invoiceCode,
        invoiceId,
        invoiceItems,
        invoiceMaker,
        invoiceNo,
        invoicePdfUrl,
        invoiceReceiver,
        invoiceRequestStatus,
        invoiceStatus,
        number,
        openBank,
        taxNo,
        taxableAddress,
        unit,
        workAddress,
        orderList
      } = await globalProperties.$api.invoiceDetail(route.query.invoiceId);
      data.bankNo = bankNo;
      data.driverIdentityNumber = driverIdentityNumber;
      data.failReason = failReason;
      data.invoiceAmount = invoiceAmount;
      data.invoiceCode = invoiceCode;
      data.invoiceId = invoiceId;
      data.invoiceItems = invoiceItems;
      data.invoiceMaker = invoiceMaker;
      data.invoiceNo = invoiceNo;
      data.invoicePdfUrl = invoicePdfUrl;
      data.invoiceReceiver = invoiceReceiver;
      data.invoiceRequestStatus = invoiceRequestStatus;
      data.invoiceStatus = invoiceStatus;
      data.number = number;
      data.openBank = openBank;
      data.taxNo = taxNo;
      data.taxableAddress = taxableAddress;
      data.unit = unit;
      data.workAddress = workAddress;
      data.orderList = orderList;
    };
    const download = () => {
      var a = document.createElement("a");
      a.href = data.invoicePdfUrl;
      a.click();
    };
    return {
      data,
      invoiceSuccessList,
      moment,
      download
    };
  }
};